<loading-image [is-loading]="isLoading"></loading-image>

<div *ngIf="isFlowFailed" class="container">
    <div class="center">
        <div class="invalid">Your login request was not successful!</div>
        <div class="login-again">
            Please
            <span (click)="reLogin()">login</span>
            again
        </div>
    </div>
</div>
